import React from "react";
import { useSelector } from 'react-redux';
import { floral } from '../language';

const PORTFOLIO_IMAGES = [
  { image: '/img/site_imgs/portfolio_01.jpg', alt: 'Close-up of a bride and groom holding a bouquet of blue delphinium and peach roses.', wide: true },
  { image: '/img/site_imgs/portfolio_02.jpg', alt: 'A colorful floral mantel installation with roses, ranunculus, and delphinium.', wide: false },
  { image: '/img/site_imgs/portfolio_03.jpg', alt: 'A white bouquet arrangement with roses and scabiosa flowers.', wide: false },
  { image: '/img/site_imgs/portfolio_04.jpg', alt: 'A reception table set with pastel floral centerpieces and candlelight.', wide: false },
  { image: '/img/site_imgs/portfolio_05.jpg', alt: 'Two ring boxes with wedding rings beside a white rose and lisianthus bouquet.', wide: true },
  { image: '/img/site_imgs/portfolio_06.jpg', alt: 'A table centerpiece with orange roses and blue cornflower beside candlelit place settings.', wide: false },
];

function Portfolio(props) {
  const languageEN = useSelector((state) => {
    return state.app.languageEN;
  });
  const language = languageEN ? 'en' : 'ch';

  return (
    <div id="portfolio" className="lf-bg-tint lf-section-anchor">
      <div className="lf-editorial lf-section py-5">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-end lf-reveal">
          <div>
            <p className="lf-eyebrow">{floral.portfolio.eyebrow[language]}</p>
            <h2 className="lf-section-heading" style={{ fontSize: '2.35rem', lineHeight: 1.22, letterSpacing: '-0.04em' }}>
              {floral.portfolio.title[language]}
            </h2>
          </div>
          <a
            className="lf-nav-link"
            style={{ borderBottom: '1px solid var(--lf-ink)', paddingBottom: '0.2rem', display: 'inline-flex', gap: '0.4rem' }}
            onClick={() => {
              const target = document.getElementById('contact');
              if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            {floral.portfolio.exploreMore[language]}
          </a>
        </div>
        <div className="lf-portfolio-grid mt-4">
          {PORTFOLIO_IMAGES.map((item, index) => {
            return (
              <div
                key={index}
                className={`lf-image-frame lf-reveal${item.wide ? ' lf-portfolio-wide' : ''}`}
                style={{ aspectRatio: item.wide ? '16 / 10' : '4 / 5' }}
              >
                <img src={item.image} alt={item.alt} loading="lazy" decoding="async" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export { Portfolio };
